/*
 * @Author: bbqin
 * @Date: 2023-01-10 20:03:34
 * @LastEditTime: 2023-01-11 13:50:14
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
// 用于二次开发的快速扩展封装

import MethodsModel from './methodsModel';

// let fastExtend = new MethodsModel();

export default MethodsModel;

// demo 在价格调整单